/**
 * The default canvas size for every icon in this package (24x24).
 * Matches the de-facto convention (Lucide, Heroicons, Phosphor regular).
 */
export const DEFAULT_ICON_SIZE = 24;
/**
 * The default stroke width for stroke-based icons.
 * Matches the @osd/ui design-system token weight.
 */
export const DEFAULT_STROKE_WIDTH = 1.5;
//# sourceMappingURL=types.js.map